<header class="l-header">
  <div class="l-header-container">
    <div class="pol-logo">
      <a routerLink="/" id="logoLink">
        <img aria-hidden="true" focusable="false" src="/assets/logo.svg" alt="UPMC Health Plan" />
        <span class="visually-hidden">UPMC Health Plan</span>
        <span>Provider OnLine</span>
      </a>
    </div>
    <div class="header-links">
      <ul>
        <li>
          <div class="references">
            <button
              #references
              (click)="referencesOpened = !referencesOpened"
              [attr.aria-expanded]="referencesOpened"
              aria-controls="referencesOptionsList"
              id="referencesMenuButton"
            >
              References
              <i class="option-list-trigger {{ referencesOpened ? 'up' : 'down' }}"></i>
            </button>
            <ul
              *ngIf="referencesOpened"
              class="dropdown-options"
              id="referencesOptionsList"
              (click)="closeOptionsMenu()"
              (keydown)="closeOptionsMenu()"
              tabindex="0"
            >
              <li *ngFor="let ref of referencesList">
                <a [target]="ref.target" [href]="ref.url" [id]="ref.id" rel="noreferrer noopener nofollow">{{ref.text}}</a>
              </li>
            </ul>
          </div>
        </li>
        <li *ngIf="userName">
          <div class="user-details">
            <button
              #userOptions
              (click)="openUserMenu()"
              [attr.aria-label]="userName + ' profile options'"
              [attr.aria-expanded]="optionsClicked"
              [attr.aria-disabled]="shouldDisableUserMenu$ | async"
              [disabled]="shouldDisableUserMenu$ | async"
              aria-controls="user-options"
              id="optionsBtn"
            >
              {{ userName | truncate : 25 }}
              <span class="option-list-trigger {{ optionsClicked ? 'up' : 'down' }}"></span>
            </button>
            <ul
              *ngIf="optionsClicked && (shouldDisableUserMenu$ | async) === false"
              class="dropdown-options"
              id="user-options"
              (click)="closeOptionsMenu()"
              (keydown.enter)="closeOptionsMenu()"
              (keydown.arrowdown)="userMenuKeyDown($event)"
              (keydown.arrowup)="userMenuKeyUp($event)"
              tabindex="0"
            >
              <li>
                <a
                  routerLink="/user/profile"
                  id="myProfileLink"
                  tabindex="0"
                  (keydown.enter)="navigate('/user/profile')"
                  >My Profile</a
                >
              </li>
              <li>
                <a routerLink="/user/my-oaa" id="myOaasLink" tabindex="0" (keydown.enter)="navigate('/user/my-oaa')"
                  >My OAAs</a
                >
              </li>
              <li>
                <a routerLink="/signout" id="signoutLink" tabindex="0" (keydown.enter)="navigate('/signout')"
                  >Sign Out</a
                >
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</header>
